module.exports = __webpack_public_path__ + "media/images/empresa/emp_factu-3d146fb9bdaba4940c81cb98a8cc9be1.svg";